import { Entity, Field } from '@adornis/baseql/decorators.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Suspension } from '../entities/suspension.js';
import { BaseLog } from './BaseLog.js';

@Entity()
export class SuspensionLog extends BaseLog {
  static override _class = 'SuspensionLog';

  @validate(nonOptional({ allowFalsy: true }))
  @Field(type => Boolean)
  locked!: boolean;

  @validate(nonOptional())
  @Field(type => Suspension)
  suspension!: Suspension;
}
